exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-backdrop[data-v-4dd227de] {\n     opacity: 1 !important;\n}\ntbody tr[data-v-4dd227de]:nth-child(odd) {\n    background: rgba(0,0,0,0.3);\n}\ntable[data-v-4dd227de] {\n    min-width: 100%;\n}\ntbody td[data-v-4dd227de],\nthead th[data-v-4dd227de] {\n    padding-left: 20px;\n}\ntbody td[data-v-4dd227de]:first-child,\nthead th[data-v-4dd227de]:first-child {\n    padding-left: 5px;\n}\ntbody td[data-v-4dd227de]:last-child,\nthead th[data-v-4dd227de]:last-child {\n    padding-right: 5px;\n}\n", ""]);

// exports
